module.exports = __webpack_public_path__ + "static/media/auschwitz.72f45b69.jpg";